class SupportTicketMessageAuthorMapper {
  static createModelFromResponse(response) {
    return {
      name: response.name,
      isAgent: response.is_agent,
      isRequestCreator: response.is_request_creator
    };
  }
}

export { SupportTicketMessageAuthorMapper };
//# sourceMappingURL=SupportTicketMessageAuthorMapper.js.map
